import { Component, OnInit } from '@angular/core';
import { ConfigurarPastaServiceService } from 'app/configurar-pasta-service.service';
import { VincularUriAlfrescoDialogComponent } from 'app/vincular-uri-alfresco-dialog/vincular-uri-alfresco-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from '@alfresco/adf-core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-vincular-uri-alfresco',
  templateUrl: './vincular-uri-alfresco.component.html',
  styleUrls: ['./vincular-uri-alfresco.component.scss']
})
export class VincularUriAlfrescoComponent implements OnInit {

  tiposDocumentais : any [];
  aspectos : any [];

  constructor(public dialog : MatDialog, public service : ConfigurarPastaServiceService,
    private authService: AuthenticationService, private router: Router ) {
    service.getAllTipos().subscribe(dados => {
      console.log(dados)
      this.tiposDocumentais = dados;
    })

    service.getAllAspectos().subscribe(aspec => {
      this.aspectos = aspec;
    })

   }

  ngOnInit() {
  }

  vincularURI(item){

    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + 'px';
    } else {
      largura = innerWidth - innerWidth / 2 + 'px';
    }
    const dialogRef = this.dialog.open(VincularUriAlfrescoDialogComponent, {
      data: { dataDialog: item },
      width: largura
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/vincular-uri-alfresco/vincular-uri-alfresco.component.ts